






























































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { UsuariosRelatorioParmDTO } from '@/interfaces/users-report';
import { getProfiles } from '@/services/profiles';
import * as service from '@/services/users-report';
import { STATUS_LIST_VALUE_LABEL } from '@/settings/consts/commons';
import { TYPES_ACCESS_VALUE_LABEL, TYPES_USERS_VALUE_LABEL } from '@/settings/consts/users';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import TextHighlight from 'vue-text-highlight';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    UiSelectClients,
    TextHighlight,
  },
})
export default class UsersReport extends BaseComponent {
  filter: any = {
    typeUser: null,
    typeAccess: null,
    status: null,
    clients: null,
    clientUnits: [],
    profile: null,
    term: null,
  };
  profiles: any = [];
  typesAccess: any = TYPES_ACCESS_VALUE_LABEL;
  typesUsers: any = [];
  statusList: any = STATUS_LIST_VALUE_LABEL;

  error = false;
  loading = false;
  loadingPdf = false;
  loadingXls = false;
  executed = false;

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();

  headers = [
    { text: 'Tipo', value: 'tipo', sortable: true },
    { text: 'Nome', value: 'nome', sortable: true },
    { text: 'CPF/CRM', value: 'cpfCrm', sortable: false },
    { text: 'Celular', value: 'celular', sortable: false },
    { text: 'E-mail', value: 'email', sortable: true },
    { text: 'Status', value: 'status', sortable: true },
    { text: 'Tipo Acesso', value: 'tipoAcesso', sortable: true },
    { text: 'Perfil', value: 'perfil', sortable: true },
    { text: 'Empresas', value: 'empresas', sortable: false },
    { text: 'Unidades', value: 'unidades', sortable: false },
    { text: 'Ultimo Acesso', value: 'dataUltimoAcesso', sortable: true },
    { text: 'Primeira Prescrição', value: 'dataPrimeiraPrescricao', sortable: true },
    { text: 'Ultima Prescrição', value: 'dataUltimaPrescricao', sortable: true },
    { text: 'Ultima Atividade', value: 'dataUltimaAtividade', sortable: true },
  ];

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  beforeMount() {
    this.getUserTypes();
    this.getProfiles();
  }

  mounted() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listUsersReport(filter);
        }),
      )
      .subscribe(
        (res) => {
          this.items = res;
          this.loading = false;
          this.pagination.page = 1;
          this.executed = true;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      );
  }

  private getProfiles(): void {
    service.listUsersReportProfiles().subscribe((data) => {
      this.profiles = data;
    });
  }

  private getUserTypes() {
    service.listUsersReportUserTypes().subscribe(res => {
      this.typesUsers = res;
      if (res.length == 1) {
        this.filter.typeUser = res[0].id;
      }
    }, error => {
      this.showToastApiError(error);
    })
  }

  public exec() {
    this.executed = false;
    this.loading = true;
    this.error = false;

    let parm = this.buildFilterParm();
    this.execBehaviorSub$.next(parm);
  }

  private buildFilterParm() {
    let parm = new UsuariosRelatorioParmDTO();
    let filter = this.filter;

    parm.idsClientes = filter.clients? filter.clients.map(u => u.id) : [];
    parm.idsUnidadesCliente = filter.clientUnits? filter.clientUnits.map(u => u.id) : [];
    parm.nomeEmailCpfCrm = filter.term;
    parm.tipoAcesso = filter.typeAccess;
    parm.ativo = filter.status;
    parm.tipoLogin = filter.typeUser;
    parm.idPerfil = filter.profile ? filter.profile.id : null;

    return parm;
  }

  public exportXls() {
    this.loader.start('Gerando XLS...');
    this.loadingXls = true;
    let parm = this.buildFilterParm();

    service.buildUsersXlsReport(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.forceFileAxiosResponseDownload(res, 'relatorio.xls');
        this.loadingXls = false;
      },
      (error) => {
        this.loader.stop();
        this.loadingXls = false;
        this.showToastApiError(error);
      },
    );
  }

  public exportPdf() {
    this.loader.start('Gerando PDF...');
    this.loadingPdf = true;
    let parm = this.buildFilterParm();

    service.buildUsersPdfReport(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.forceFileAxiosResponseDownload(res, 'relatorio.pdf');
        this.loadingPdf = false;
      },
      (error) => {
        this.loader.stop();
        this.loadingPdf = false;
        this.showToastApiError(error);
      },
    );
  }

}
